import { codeSplit } from 'bernie-core';

export const roomsAndRatesLoadable = {
  webpackChunkName: 'infosite-RoomsAndRates',
  codeSplit: codeSplit(() => import(/* webpackChunkName: "infosite-RoomsAndRates" */ './index') as any)
};
